import { render, staticRenderFns } from "./EditExtraServiceDetails.vue?vue&type=template&id=a53da1d4"
import script from "./EditExtraServiceDetails.vue?vue&type=script&lang=ts"
export * from "./EditExtraServiceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports